/* eslint import-x/no-extraneous-dependencies: ["error", {"devDependencies": true}] */
import type { SliceUnion } from '../slices';
import type { PrismicDocument } from '@prismicio/client';

export enum ContentType {
  breed = 'breed',
  breeds = 'breeds',
}

export interface SliceUnionBody {
  body: SliceUnion[];
}

export interface ContentDocument<D, T extends ContentType>
  extends PrismicDocument {
  data: D & SliceUnionBody;
  type: T;
  buildId: string;
}
